import { ScheduleFrequency } from '@/enums/scheduleFrequency.enum';
import { ScheduleType } from '@/enums/scheduleType.enum';

export default {
  title: 'Harmonogram składowy',
  type: 'object',
  properties: {
    name: {
      title: 'schema.schedule.name',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'schema.schedule.description',
      type: 'string',
      fieldRequired: false
    },
    start: {
      title: 'schema.schedule.start',
      type: 'string',
      format: 'date',
      fieldRequired: true
    },
    end: {
      title: 'schema.schedule.end',
      type: 'string',
      format: 'date',
      fieldRequired: true,
      minimum: 'this.start'
    },
    frequencyType: {
      title: 'schema.schedule.frequencyType',
      type: 'string',
      fieldRequired: true
    },
    type: {
      title: 'schema.schedule.type',
      type: 'string',
      fieldRequired: true
    },
    frequency: {
      title: 'schema.schedule.frequency',
      type: 'number',
      fieldRequired: `!(this.frequencyType === '${ScheduleFrequency.ONCE}' || this.frequencyType === '${ScheduleFrequency.HOLIDAY}')`
    },
    day: {
      type: 'number',
      fieldRequired: `this.frequencyType !== '${ScheduleFrequency.ONCE}' &&
      this.frequencyType !== '${ScheduleFrequency.HOLIDAY}' &&
      this.frequencyType !== '${ScheduleFrequency.DAILY}'`
    },
    month: {
      title: 'schema.schedule.month',
      type: 'number',
      fieldRequired: `this.frequencyType === '${ScheduleFrequency.YEARLY}'`
    },
    week: {
      title: 'schema.schedule.week',
      type: 'number',
      fieldRequired: `this.frequencyType === '${ScheduleFrequency.NTH_WEEKDAY_OF_MONTH}'`,
      maximum: 5
    },
    hour: {
      title: 'schema.schedule.hour',
      type: 'number',
      fieldRequired: `this.type === '${ScheduleType.INCLUDE}'`,
      minimum: 0,
      maximum: 23
    },
    minute: {
      title: 'schema.schedule.minute',
      type: 'number',
      fieldRequired: `this.type === '${ScheduleType.INCLUDE}'`,
      minimum: 0,
      maximum: 59
    },
    order: {
      title: 'schema.schedule.order',
      type: 'number',
      fieldRequired: true
    },
    duration: {
      title: 'schema.schedule.duration',
      type: 'number',
      fieldRequired: false
    }
  }
};
